// extracted by mini-css-extract-plugin
module.exports = {"news-item-box":"O","newsItemBox":"O","img-box":"P","imgBox":"P","img-mask-box":"Q","imgMaskBox":"Q"};